import data from "../../data/lent.json";

export interface Resource {
  url: string;
  label: string;
  description: string;
}

export type QuestionBlock = {
  title?: string;
  intro?: string | string[];
  questions: string[];
};

export interface ResponseBlock {
  title: string;
}

export interface OptionBlock extends ResponseBlock {
  options: string[];
}

export interface ActionBlock extends ResponseBlock {
  action: string;
  url: string;
}

export type OptionalIntro<T> =
  | T
  | {
      intro: string | string;
      content: T;
    };

export interface Entry {
  id: string;
  title: string;
  date: string;
  video?: string;
  scripture: string;
  themes: string[];
  ask: OptionalIntro<QuestionBlock[]>;
  talk: OptionalIntro<(ResponseBlock | OptionBlock | ActionBlock)[]>;
  respond: OptionalIntro<string[]>;
  resources: Resource[];
}

const useEntries = (): { entries: Entry[] } => {
  return { entries: data };
};

function ensureIntro<T>(block: OptionalIntro<T>) {
  if ("intro" in block) {
    return block;
  }

  return {
    intro: "",
    content: block,
  };
}

export default useEntries;
export { ensureIntro };
